import * as React from 'react';
import { useTranslation } from 'next-i18next';
import { ArrowRightIcon } from '@heroicons/react/24/outline';
import { useIntercom } from 'react-use-intercom';
import { useRouter } from 'next/router';
import tw from 'twin.macro';

import { ButtonV2 } from '@restworld/ui-ds';
import { HeadphoneIcon } from '@restworld/utils-common';
import { useGettingStartedPage } from './restaurant-onboarding-modal.hooks';

interface IRestaurantOrContactAlreadyExistsProps {
  title?: string;
  subtitle?: string;
}

const Container = tw.div`w-full h-full inline-flex flex-col justify-center items-center gap-10`;
const Section = tw.div`self-stretch flex flex-col justify-start items-start gap-4`;
const Title = tw.h5`self-stretch text-center justify-start text-neutral-700 text-xl font-semibold`;
const Subtitle = tw.h5`self-stretch text-center justify-start text-neutral-200 text-base font-medium`;
const HeaderTitle = tw.h5`text-center justify-start text-neutral-700 text-sm font-medium`;
const ButtonTitle = tw.h5`text-purple-700 text-base font-semibold`;

const RestaurantOrContactAlreadyExists: React.FunctionComponent<IRestaurantOrContactAlreadyExistsProps> = ({
  title,
  subtitle,
}) => {
  const { t } = useTranslation('restaurant-onboarding');
  const { showMessages } = useIntercom();
  const router = useRouter();
  const isGettingStartedPage = useGettingStartedPage();

  return (
    <Container>
      <Section>
        <Title>{title}</Title>
        <Subtitle>{subtitle}</Subtitle>
      </Section>
      {isGettingStartedPage && (
        <Section>
          <HeaderTitle>{t('was_it_you_or_someone_from_your_staff')}</HeaderTitle>
          <ButtonV2
            EndIcon={ArrowRightIcon}
            variant="secondary-restworld"
            tw="w-full"
            size="md"
            onClick={(e) => {
              e.preventDefault();
              router.push('/login');
            }}
          >
            <ButtonTitle>{t('go_to_login')}</ButtonTitle>
          </ButtonV2>
        </Section>
      )}
      <Section>
        <HeaderTitle>{t('it_wasnt_you')}</HeaderTitle>
        <ButtonV2
          EndIcon={HeadphoneIcon}
          variant="secondary-restworld"
          tw="w-full"
          size="md"
          onClick={(e) => {
            e.preventDefault();
            showMessages();
          }}
        >
          <ButtonTitle>{t('ask_support')}</ButtonTitle>
        </ButtonV2>
      </Section>
    </Container>
  );
};

export default RestaurantOrContactAlreadyExists;
